var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6532 0.3994C15.1156 0.931933 15.1156 1.79534 14.6532 2.32787L8.33736 9.6006C7.8749 10.1331 7.1251 10.1331 6.66264 9.6006L0.346847 2.32787C-0.115616 1.79534 -0.115616 0.931934 0.346847 0.399401C0.80931 -0.133133 1.55911 -0.133133 2.02157 0.3994L7.5 6.70789L12.9784 0.3994C13.4409 -0.133133 14.1907 -0.133133 14.6532 0.3994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6befbd3cac60bbaf2f399400302b9985.svg";
export { ForwardRef as ReactComponent };